import { SocketAsFetch } from '@leagueplatform/socket-as-fetch';
import { UserProfileAggregate } from '@leagueplatform/user-profile-api';
import {
  PATIENT_PORTAL_SYSTEM_UUIDS,
  type PatientPortalSystemOptions,
} from 'types/patient-portal-system.types';

const SET_USER_PROFILE_MESSAGE_TYPE = 'set_user_profile';

export type SetUserProfileBody = Record<string, unknown>;

export type SetUserProfileResponse = {
  message_type: 'user_profile_set';
  message_id: string;
  info: UserProfileAggregate['user_profile'] & {
    custom_fields: UserProfileAggregate['custom_fields'];
  };
};

export const setUserProfile = (
  systemId: PatientPortalSystemOptions,
  body: SetUserProfileBody = {},
): Promise<SetUserProfileResponse> =>
  SocketAsFetch.fetch({
    message_type: SET_USER_PROFILE_MESSAGE_TYPE,
    info: body,
    custom_fields: {
      systemId: PATIENT_PORTAL_SYSTEM_UUIDS[systemId],
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } as any);
